/**
 * Cart page quantity controls.
 *
 * Shopify can change a line-item key when automatic discounts change. After a
 * successful mutation, reload the server-rendered cart so every key, discount,
 * checkout control, and line price is authoritative for the next interaction.
 */
(function() {
  'use strict';

  if (!window.AnimeCart) {
    // The native cart form remains usable when the shared cart script fails.
    return;
  }

  let navigationPending = false;
  document.documentElement.classList.add('cart-ajax-ready');

  function setItemPending(item, pending) {
    if (!item) return;
    item.style.opacity = pending ? '0.6' : '';
    item.style.pointerEvents = pending ? 'none' : '';
    item.setAttribute('aria-busy', String(pending));
  }

  function reloadAuthoritativeCart() {
    navigationPending = true;
    window.location.reload();
  }

  async function updateQuantity(input, newValue, previousValue) {
    if (!input || navigationPending) return;

    const key = input.dataset.key;
    const item = input.closest('.cart-item');
    if (!key) return;

    input.value = newValue;
    setItemPending(item, true);

    try {
      await window.AnimeCart.updateItem(key, newValue);
      reloadAuthoritativeCart();
    } catch (error) {
      input.value = previousValue;
      input.defaultValue = previousValue;
      setItemPending(item, false);

      if (!error?.cartReported) {
        window.AnimeCart.showToast?.(error?.message || 'Failed to update quantity. Please try again.', 'error');
      }
    }
  }

  window.updateCartQuantity = function(key, delta) {
    if (navigationPending || window.AnimeCart.isUpdating?.()) return;

    const input = [...document.querySelectorAll('.cart-page .quantity-input')]
      .find((candidate) => candidate.dataset.key === String(key));
    if (!input) return;

    const previousValue = Number.parseInt(input.value, 10) || 0;
    const nextValue = Math.max(0, previousValue + Number(delta || 0));
    updateQuantity(input, nextValue, previousValue);
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.cart-page .quantity-input');
    if (!input || navigationPending || window.AnimeCart.isUpdating?.()) return;

    const previousValue = Number.parseInt(input.defaultValue, 10) || 0;
    const requestedValue = Number.parseInt(input.value, 10);
    const nextValue = Number.isFinite(requestedValue) ? Math.max(0, requestedValue) : previousValue;

    if (nextValue === previousValue) {
      input.value = previousValue;
      return;
    }

    updateQuantity(input, nextValue, previousValue);
  });

  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('.cart-page [data-cart-quantity]');
    if (quantityButton) {
      event.preventDefault();
      window.updateCartQuantity(quantityButton.dataset.key, Number(quantityButton.dataset.delta));
      return;
    }

    if (event.target.closest('.cart-page .remove-btn') && window.AnimeCart.isUpdating?.()) {
      event.preventDefault();
    }
  });

  if (!document.getElementById('cart-page-styles')) {
    const styles = document.createElement('style');
    styles.id = 'cart-page-styles';
    styles.textContent = `
      .cart-item {
        transition: opacity 0.2s ease;
      }
    `;
    document.head.appendChild(styles);
  }
})();
